import { MOST_ACTIVE_BY_VALUE, MOST_ACTIVE_BY_VALUE_STREAM, MOST_ACTIVE_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iMostActiveByValue";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    mostActiveByValueList: [],
    latestUpdatedTime: "",
};
const mostActiveByValueReducer = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case MOST_ACTIVE_BY_VALUE:
            return Object.assign(Object.assign({}, state), { mostActiveByValueList: action.payload.mostActiveByValueList });
        case MOST_ACTIVE_BY_VALUE_STREAM:
            return Object.assign(Object.assign({}, state), { mostActiveByValueList: drivingMarketStream(state.mostActiveByValueList, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case MOST_ACTIVE_LAST_UPDATED_TIME:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default mostActiveByValueReducer;
